import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import cookie from 'react-cookies';
import {ValidateState} from '../../../functions';
import {API_URL} from '../../../constants';
import {updateValueInJson, showModalPageClass, hideModalPageClass, validateAccesoGeneral, getRoles, esUrl} from '../../../functions';
import axios from 'axios';
import $ from 'jquery';
import Sortable from 'sortablejs';
import { toast } from 'react-toastify';

import {showModalModulosWeb, showModalFormId} from '../../../functions';
import AdmBanner from './Modulos/Banner/banner';
import AdmPerfilador from './Modulos/Perfilador/perfilador';
import AdmDetallePerfilador from './Modulos/DetallePerfilador/detallePerfilador';
import AdmBeneficioCliente from './Modulos/BeneficioCliente/beneficioCliente';
import AdmNoticia from './Modulos/Noticia/noticia';
import AdmModuloServicioExportador from './Modulos/ModuloServicioExportador/moduloServicioExportador';
import AdmModuloReporteExportacion from './Modulos/ModuloReporteExportacion/moduloReporteExportacion';
import AdmModuloEvento from './Modulos/ModuloEvento/moduloEvento';
import AdmDiagnosticoProducto from './Modulos/DiagnosticoProducto/diagnosticoProducto';
import AdmProductoPriorizado from './Modulos/ProductoPriorizado/productoPriorizado';
import AdmCertificacion from './Modulos/Certificacion/certificacion';
import AdmCapsulaAprendizaje from './Modulos/CapsulaAprendizaje/capsulaAprendizaje';
import AdmRegulacionPais from './Modulos/RegulacionPais/regulacionPais';
import AdmFormacionExportador from './Modulos/FormacionExportador/formacionExportador';
import AdmPotencialExportador from './Modulos/PotencialExportador/potencialExportador';
import AdmInformeMercado from './Modulos/InformeMercado/informeMercado';
import AdmDocumentacionExportar from './Modulos/DocumentacionExportar/documentacionExportar';
import AdmExportaFacil from './Modulos/ExportaFacil/exportaFacil';
import AdmPreciosFob from './Modulos/PreciosFob/preciosFob';
import AdmGuiasExportador from './Modulos/GuiasExportador/guiasExportador';
import AdmExportacionProductoMercado from './Modulos/ExportacionProductoMercado/exportacionProductoMercado';
import AdmExportacion from './Modulos/Exportacion/exportacion';
import AdmPaginasInteres from './Modulos/PaginasInteres/paginasInteres';
import AdmSliderSectoresProductivos from './Modulos/SliderSectoresProductivos/sliderSectoresProductivos';
import AdmPerfilProductoMercado from './Modulos/PerfilProductoMercado/perfilProductoMercado';
import AdmEstudioMercado from './Modulos/EstudioMercado/estudioMercado';
import AdmExportacionDirectorioContacto from './Modulos/ExportacionDirectorioContacto/exportacionDirectorioContacto';
import AdmHerramientaPymes from './Modulos/HerramientaPymes/herramientaPymes';
import AdmHerramientaExterna from './Modulos/HerramientaExterna/herramientaExterna';
import AdmBoletinInteligencia from './Modulos/BoletinInteligencia/boletinInteligencia';
import AdmProgramaCapacitacion from './Modulos/ProgramaCapacitacion/programaCapacitacion';
import AdmMiercolesExportador from './Modulos/MiercolesExportador/miercolesExportador';
import AdmCalendarioFormacion from './Modulos/CalendarioFormacion/calendarioFormacion';
import AdmPublicacion from './Modulos/Publicacion/publicacion';
import AdmSliderProductoExportacion from './Modulos/SliderProductoExportacion/sliderProductoExportacion';
import AdmHerramientaAnalisis from './Modulos/HerramientaAnalisis/herramientaAnalisis';
import AdmNuestrasOficinas from './Modulos/NuestrasOficinas/nuestrasOficinas';
import AdmPuedeInteresarte from './Modulos/PuedeInteresarte/puedeInteresarte';
import AdmInfografia from './Modulos/Infografia/infografia';
import AdmGlosario from './Modulos/Glosario/glosario';
import AdmPreguntasFrecuentes from './Modulos/PreguntasFrecuentes/preguntasFrecuentes';
import AdmRegistroUsuario from './Modulos/RegistroUsuario/registroUsuario';
import AdmEncuestaSatisfaccion from './Modulos/EncuestaSatisfaccion/encuestaSatisfaccion';
import AdmCalendarioDetalle from './Modulos/CalendarioDetalle/calendarioDetalle';
import AdmCalendarioEventos from './Modulos/CalendarioEventos/calendarioEventos';
import AdmMapaSitio from './Modulos/MapaSitio/mapaSitio';
import AdmBannerImagen from './Modulos/BannerImagen/bannerImagen';
import AdmMenuAncla from './Modulos/MenuAncla/menuAncla';
import AdmSliderCompetitividadGlobal from './Modulos/SliderCompetitividadGlobal/sliderCompetitividadGlobal';
import AdmContenido from './Modulos/Contenido/contenido';
import ModalMultimedia from '../../Partials/ModalMultimedia';
import BuscadorPartidas from './Modulos/BuscadorPartidas/buscadorPartidas';
import BuscadorProductos from './Modulos/BuscadorProductos/buscadorProductos';
import BuscadorPaises from './Modulos/BuscadorPaises/buscadorPaises';
import AdmBannerImagenHome from './Modulos/BannerImagenHome/bannerImagenHome';
import AdmNoticiasHome from './Modulos/NoticiasHome/noticiasHome';
import AdmMacrotendenciaHome from './Modulos/MacrotendenciasHome/macrotendenciaHome';
import AdmEventoHome from './Modulos/EventoHome/eventoHome'

let moduloOriginal = [];
export default class EditarPagina extends Component {

    constructor(props) {

        super(props);

        this.state = {
            key: 0,
            tituloLongitud:0,
            descripcionLongitud:0,
            pModIdEdit:0,
            mWebEdit:0,
            resource: {
                pagi_Id:0,
                pagi_Titulo:"",
                pagi_Enlace:"",
                pagi_SeoTitulo:"",
                pagi_SeoImagen:"",
                pagi_Canonical:"",
                pagi_SeoDescripcion:"",
                pagi_SeguirEnlace:0,
                pagi_MostrarMotores:0,
                pagi_Script:"",
                pagi_PaginaSuperior:null,
                sect_Id:0,
                pweb_Id:0,
                plan_Id:0,
                pagi_Orden:0,
                pagi_Activo:true,
                existUrl:false
            },
            Validacion: {
                pagi_Titulo: {
                    Error: false,
                },
                pagi_Enlace: {
                    Error: false,
                }
            },
            modulosDisponibles: [],
            modulosWeb: [],
            paginasPadre: [],
            plantillas: [],
            sectores: [],
            perfiles: [],
            modulosModal:[],
            recursoNoticias: [],
            calendariosFormacion: [],
            herramientaAnalisis: [],
            paises: [],
            hasError:false,
            hasErrorProceso:false,
            added: false,
            security: cookie.load('user'),
            roles: [],
            fieldReturnMultimedia:"",
            agrupador:"",
            menuGeneral:[]
          }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);
        this.getResponseMultimedia = this.getResponseMultimedia.bind(this);
      }

    getResponseMultimedia = (urlSeleccionada) => {
        let resource = this.state.resource;
        let fieldReturn = this.state.fieldReturnMultimedia;

        if(fieldReturn!== ""){

            resource[fieldReturn] = urlSeleccionada;

            this.setState({resource:resource, fieldReturnMultimedia:""});
        }

        hideModalPageClass("divGestorArchivosMultimedia");
    }

    showModalMultimedia = (clase = "", campo = "") => {
        this.setState({fieldReturnMultimedia:campo});
        showModalPageClass(clase);
    }


    componentDidMount(){
        if($('#containerPanel').is("*")){
            $('#containerPanel').hide();
        }

        let locationState = this.props.location.state;
        let pathNameList = "/paginas";

        var roles = getRoles(this.state.security);
        var rol = roles.length > 0 ? roles[0].nRolCodigo : "";

        validateAccesoGeneral(locationState, pathNameList, rol);

        const url = `${API_URL}PaginaUX/Recursos`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){

                moduloOriginal = data.result.modulos;
                console.log("data paginas", data.result);

                this.setState({
                    paginasPadre: data.result.paginasPadre,
                    plantillas: data.result.plantillas,
                    sectores: data.result.sectores,
                    perfiles: data.result.perfiles,
                    recursoNoticias: data.result.recursoNoticias,
                    paises: data.result.paises,
                    modulosModal: moduloOriginal,
                    calendariosFormacion:data.result.calendariosFormacion,
                    herramientaAnalisis:data.result.herramientaAnalisis
                });

                this.loadModulos();
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    loadModulos()
    {

        let pagina_id = this.state.resource.pagi_Id;

        const url = `${API_URL}PaginaUX/ObtenerModulosWeb/${pagina_id}`;
        axios.get(url).then(response => response.data)
        .then((data) => {
            if(data.statusCode == 200){
                this.setState({
                    modulosWeb: data.result
                });
				let pagiId = this.state.resource.pagi_Id;
				Sortable.create(document.getElementById('divCamposEditarPagina'), {
					handle: "a.btnMoverPagina" ,
					revert: true,
					connectToSortable: ".divCamposEditarPagina" ,
					update: function()
					{
					},
					store: {
						get: function (sortable) {
							let _OrdenId = "";
							$(".divTituloCampoPagina").each(function(index)
							{
								_OrdenId += $(this).data("idmodulo")+"|"+(index+1)+",";
							});
							$("#txtOrdenPagina").val(_OrdenId);
							return ;
						},
						set: function (sortable)
						{
                            let _OrdenId = "";

							$(".divTituloCampoPagina").each(function(index)
							{
								_OrdenId += $(this).data("idmodulo")+"|"+(index+1)+",";
							});
							$("#txtOrdenPagina").val(_OrdenId);

							const urlOrden = `${API_URL}PaginaUX/OrdenarModulos/${pagiId}/${_OrdenId}`;
							axios.get(urlOrden).then(response => response.data)
							.then((data) =>
							{
								toast.success('Se guardó el nuevo orden');
								this.setState({ modulosWeb: data.result });
							})
							.catch(error => {
							});
						}
					}
				});
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    componentWillMount(){

        var key = this.props.match.params.id;
        const url = `${API_URL}PaginaUX/Seleccionar/${key}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            console.log("data", data);
            this.setState({ 
                resource: data.result, 
                response: data, 
                error: data.Error 
            });

        })
        .catch(error => {
            console.log("¡Error al inicializar!");
        });

        this.loadModulosDisponibles();

    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.callSearchModulos(e);
        }
    }

    callSearchModulos = (e) => {
        e.preventDefault();
        let texto = document.getElementById('titulo_modulo').value;
        this.loadModulosDisponibles(texto);
    }

    loadModulosDisponibles = (textoFilter = '') =>
    {
        let url = `${API_URL}GeneralUX/ObtenerLModulosWebNombre`;

        if(textoFilter != ''){
            url = `${API_URL}GeneralUX/ObtenerLModulosWebNombre/${textoFilter}`;
        }

        axios.get(url).then(response => response.data)
        .then((data) => {
            let resourceModulos = this.state.modulosDisponibles;
            resourceModulos = data.result;
            this.setState({modulosDisponibles:resourceModulos});
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    handleClickCancel(e) {
        if(e != undefined){
            e.preventDefault();
        }
        const {history: {push}} = this.props;
        push('/paginas');
     }

     callFunctionButton = (event) => {

        event.preventDefault();

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.pagi_Titulo == '') {
            newState.Validacion.pagi_Titulo = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.pagi_Enlace == '' || !esUrl(newState.resource.pagi_Enlace))
		{
            newState.Validacion.pagi_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        const url = `${API_URL}PaginaUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'pagi_UsuarioEdicion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url,
        JSON.stringify(formData),
        { headers: {
        'Content-Type': 'application/json; charset=UTF-8' ,
        'Accept': 'application/json'
        }
        }
        ).then(
        (data)=> {

            if (data.data.isSucess)
            {

                if(data.data.result.existUrl){

                    let newState = this.state;
                    newState.resource.existUrl = true;
                    newState.Validacion.pagi_Enlace = {Error: true};
                    this.setState(newState);

                }else{
                    let stateResponse = this.state;

                    stateResponse.added = true;

                    this.setState(stateResponse);

                    setTimeout(() => {
                        this.handleClickCancel();
                    }, 1000);

                    setTimeout(() => {
                        this.setState({added:false});
                    }, 5000);
                }

            } else
            {
                this.setState({hasErrorProceso:true});

                setTimeout(() => {
                    this.setState({hasErrorProceso:false});
                }, 3000);
            }
        }
        ).catch((error)=> {
        console.log('Error no controlado.');
        this.setState({loading:false});
        });
    }

    checkedValidate = (item) => {
        let resource = this.state.resource;
        resource[item] = !resource[item];

        this.setState({resource:resource});
    }

    handleInputChange(event) {

        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;

        if(target.name == 'pagi_Enlace'){
            value = value.replace(/\s/g,'');
            copyResource['existUrl'] = false;
        }

        copyResource[target.name] = value;

        let tituloLongitud = this.state.tituloLongitud;
        let descripcionLongitud = this.state.descripcionLongitud;

        let validaciones = this.state.Validacion;
        validaciones[target.name] = {
            Error: false,
        }

        if(target.name == 'pagi_Titulo'){
            tituloLongitud = value.length;
        }
        if(target.name == 'pagi_SeoDescripcion'){
            descripcionLongitud = value.length;
        }
        this.setState({
            resource: copyResource,
            tituloLongitud: tituloLongitud,
            descripcionLongitud: descripcionLongitud,
            Validacion: validaciones
        });
    }

    agregarModuloWeb = (e) => {
        e.preventDefault();

        this.setState({pModIdEdit:0, mWebEdit:0});
        setTimeout(() => {
            showModalModulosWeb(e);
        }, 100);

    }

    getResponse = (result) => {

        if(result){
            this.setState({pModIdEdit:0, mWebEdit:0});
            this.loadModulos();
        }
     }

     editarPaginaModulo = (entity, e) => {
        e.preventDefault();

        this.setState({pModIdEdit:entity.pmod_Id, mWebEdit:entity.mweb_Id});

        showModalFormId(entity.mweb_Id, e)
     }

     eliminarPaginaModulo = async(entity, e) => {

        e.preventDefault();

        const url = `${API_URL}PaginaUX/EliminarPaginaModulo`;

        let dataToSave=updateValueInJson(entity, 'pmod_UsuarioEliminacion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        await axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {
                    if (data.data.isSucess)
                    {
                        this.loadModulos();
                    } else
                    {
                        console.log('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                console.log('Error no controlado.');
                this.setState({loading:false});
            });
    }

    render() {

        let pagina_id = this.state.resource.pagi_Id;

        return (
            <div className="ContenedorDeNoticias">
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="" />
                        <a  href="/">
                            / Panel de Configuración General
                        </a >
                        <Link to="/administradores">
                            / Administradores
                        </Link>
                        <span> / Editar Página</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Editar Página
                </div>

                {
                    this.state.hasErrorProceso ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, no se pudo realizar la actualización.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.resource.existUrl ?
                    <div className="relative">
                        <div className="textAlertaError">
                            <div>Error, la url ingresada ya fue asignada a una página.</div>
                        </div>
                    </div> : null
                }

                {
                    this.state.added ?
                    <div className="relative">
                        <div className="textAlertaOK">
                            <div>Se actualizó el registro correctamente. Se redireccionará al listado.</div>
                        </div>
                    </div>: null
                }

                <div className="div_Modulos_Noticias">


                    <div className="div_WrapperEditarPagina">

                        <div className="txtFile x-1">
                            <input type="text" placeholder="Título" name='pagi_Titulo' value={this.state.resource.pagi_Titulo} maxLength={200} className={this.state.Validacion.pagi_Titulo.Error ? "error" : ""}
                            onChange={this.handleInputChange}/>
                            <span data-length={200}>{this.state.tituloLongitud}/200</span>
                        </div>

                        <div className="txtFile x-1">
                            <input type="text" placeholder="Enlace" name='pagi_Enlace' value={this.state.resource.pagi_Enlace} className={this.state.Validacion.pagi_Enlace.Error ? "error" : ""}
                            onChange={this.handleInputChange}/>
                        </div>

						<div className="txtFile x-1 relative">
							<select name='pagi_PaginaSuperior' id='pagi_PaginaSuperior' onChange={this.handleInputChange}>
                                <option value="0">Página Superior</option>
                                {
                                    this.state.paginasPadre.length > 0 ?
                                    this.state.paginasPadre.map((padre) => {
                                        // console.log(padre);

                                        return <option 
                                            value={padre.id} 
                                            selected={(this.state.resource.pagi_PaginaSuperior == padre.id) ? true : false}
                                        >
                                            {padre.nombre !== null ? padre.nombre.toUpperCase() : ""}
                                        </option>
                                    })
                                    : null
                                }
                            </select>
                        </div>

                        <div className="txtFile x-1 relative" style={{display:"none"}}>
							<select name='plan_Id' id='plan_Id' onChange={this.handleInputChange}>
                                <option value="0">Plantilla</option>
                                {
                                    this.state.plantillas.length > 0 ?
                                    this.state.plantillas.map((plantilla) => (
                                        <option value={plantilla.id} key={plantilla.id} selected={(this.state.resource.plan_Id == plantilla.id) ? true : false}>{plantilla.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>



                        <div className="txtFile x-1 relative" style={{display:"none"}}>
							<select name='sect_Id' id='sect_Id' onChange={this.handleInputChange}>
                                <option value="0">Seleccionar Sector</option>
                                {
                                    this.state.sectores.length > 0 ?
                                    this.state.sectores.map((sector) => (
                                        <option value={sector.id} selected={(this.state.resource.sect_Id == sector.id) ? true : false}>{sector.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>

                        <div className="txtFile x-1" style={{display:"none"}}>
							<select name='pweb_Id' id='pweb_Id' onChange={this.handleInputChange}>
                                <option value="0">Seleccionar Perfil</option>
                                {
                                    this.state.perfiles.length > 0 ?
                                    this.state.perfiles.map((perfil) => (
                                        <option value={perfil.id} selected={(this.state.resource.pweb_Id == perfil.id) ? true : false}>{perfil.nombre.toUpperCase()}</option>
                                    ))
                                    : null
                                }
                            </select>
                        </div>

                        <div className="divCamposEditarPagina" id="divCamposEditarPagina">
                            {
                                this.state.modulosWeb.length > 0 ?
                                this.state.modulosWeb.map((modulo, index) => (
                                    <div className="divTituloCampoPagina" data-idmodulo={modulo.pmod_Id} key={"mpage_" + modulo.pmod_Id}>
                                        {modulo.nombreModulo}
                                        <div className="btnCamposEditarPagina">
                                            {
                                                ! modulo.mweb_Estatico ?
                                                <React.Fragment>
                                                    <a href="#"className="btnEditarPagina noneEvent" onClick={(e) => this.editarPaginaModulo(modulo, e)}/>
													
													
                                                    <a href className="btnPageModuloEliminar aEliminarMenu2"/>
													<div className="c_divAlertaCapa">
														<div className="divAlertaCapa">
															<div className="divAlerta">
																<h2>&iquest;Seguro de eliminar?</h2>
																<div className="divAlertaBtn">
																	<a href="#" className="btnAlertaAceptar" onClick={(event) => this.eliminarPaginaModulo(modulo, event)}>ACEPTAR</a>
																	<a href="#" className="btnAlertaCancelar">CANCELAR</a>
																</div>
															</div>
														</div>
													</div>
													
													
                                                    <a href="#"className="btnMoverPagina" />
                                                </React.Fragment>
                                                : null
                                            }

                                        </div>
                                    </div>
                                ))
                                :
                                <div className="divTituloCampoPagina">
                                    NO EXISTEN MODULOS ASIGNADOS
                                </div>
                            }

							<input type="hidden" id="txtOrdenPagina" namd="txtOrdenPagina" value="" />
                        </div>
                        <a href="#"className="btnAgregarPagina noneEvent" onClick={(e) => this.agregarModuloWeb(e)}>AGREGAR</a>
                    </div>

                    <div className="clear"></div>

                    <div className="divModulo_Seo">
                        <h2>Configuración <strong>SEO</strong></h2>
                        <div className="divWrapperModulo_Seo">

                            <div className="txtFile x-2">
                                <input type="text" placeholder="SEO Title" name='pagi_SeoTitulo' value={this.state.resource.pagi_SeoTitulo}
                                onChange={this.handleInputChange}/>
                            </div>

                            <div className="txtFile x-1">
                                <textarea type="text" placeholder="SEO Descripción" name='pagi_SeoDescripcion' value={this.state.resource.pagi_SeoDescripcion} maxLength={200}
                                onChange={this.handleInputChange} style={{height:"100px"}}/>
                                <span data-length={200}>{this.state.descripcionLongitud}/200</span>
                            </div>

                            <div className="txtFile x-1 relative">
                            <span className="subirImagen" data-id="txtIconoCategoria" onClick={() => this.showModalMultimedia("divGestorArchivosMultimedia", "pagi_SeoImagen")}/>
                                <input type="text" placeholder="SEO Imagen" name='pagi_SeoImagen' value={this.state.resource.pagi_SeoImagen} maxLength={1000}
                                onChange={this.handleInputChange}/>
                            </div>

                            <div className="txtFile x-1">
                                <input type="text" placeholder="URL Canonical" name='pagi_Canonical' value={this.state.resource.pagi_Canonical}
                                onChange={this.handleInputChange}/>
                            </div>

                            <div className="divWrapperActive">
                                <div>
                                    <span>Motores de busqueda <br />seguir enlaces</span>
                                </div>

                                <div>
                                    <div className={this.state.resource.pagi_SeguirEnlace ? "containerActive backgroundPosition" : "containerActive"}
                                    onClick={() => this.checkedValidate("pagi_SeguirEnlace")}>
                                        <div className={this.state.resource.pagi_SeguirEnlace ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.resource.pagi_SeguirEnlace ? "Activado" : "Desactivado"}</span>
                                </div>

                                <div>
                                    <span>Mostrar Pagina <br />Motores de Búsqueda </span>
                                </div>

                                <div>
                                    <div className={this.state.resource.pagi_MostrarMotores ? "containerActive backgroundPosition" : "containerActive"}
                                    onClick={() => this.checkedValidate("pagi_MostrarMotores")}>
                                        <div className={this.state.resource.pagi_MostrarMotores ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.resource.pagi_MostrarMotores ? "Activado" : "Desactivado"}</span>
                                </div>

                            </div>

                        <div className="txtArea x-1">
                            <textarea placeholder="Pegue aquí su código JavaScript" value={this.state.resource.pagi_Script} name="pagi_Script"  onChange={this.handleInputChange} style={{height:"100px"}}/>
                        </div>
                    </div>
                    </div>


                    <div className="divContenedorBtn_Noticias">
                        <a href="#"  className="btnActivo"  onClick={(event) => this.callFunctionButton(event)}>GUARDAR </a>
                        <a href="#"  onClick={(event) => this.handleClickCancel(event)}>VOLVER</a>
                    </div>
                </div>
                <br />
                <br />

                {/* CONTENEDOR DE MODAL DE MODULOS */}
                <div className="_Container_modals">

                    <div className="divModalModulos popUpGeneral" style={{display:"none"}}>
                        <div className="divLayerPopup_ModalPaginas">
                            <div className="divPopup_ModalPaginas">
                            <div className="divClosePopup_Modals" />
                            <h2>Modulos </h2>
                            <div className="divWrapperModalPaginas">
                                <div className="divSearchModalPaginas">
                                    <input type="text" placeholder="Encontrar módulo" name="titulo_modulo" id="titulo_modulo" onKeyDown={this._handleKeyDown}/>
                                    <input type="submit" defaultValue="Buscar" onClick={(e) => this.callSearchModulos(e)}/>
                                </div>

                                <div className="divConfiguracion_ModulosWeb">
                                    {
                                        this.state.modulosDisponibles.length > 0 ?
                                        this.state.modulosDisponibles.map((modulo) => (
                                            <div className="divModulos_General" key={modulo.id}>
                                                <a href="#" onClick={(e) => showModalFormId(modulo.id, e)}>
                                                    <img src="../static/images/icoConfiguracion.png" alt="" />
                                                    <span>{modulo.nombre.toUpperCase()}</span>
                                                </a>
                                            </div>
                                        ))
                                        : null
                                    }

                                </div>

                            </div>
                            </div>
                        </div>
                    </div>

                    {
                        this.state.modulosModal.length > 0 && pagina_id > 0 && this.state.perfiles.length  > 0 ?
                        this.state.modulosModal.map((modulo) => (
                            this.renderSwitch(
                                modulo,
                                pagina_id,
                                this.state.pModIdEdit,
                                this.state.mWebEdit,
                                this.getResponse.bind(this),
                                {
                                    perfiles:this.state.perfiles,
                                    sectores:this.state.sectores,
                                    recursoNoticias:this.state.recursoNoticias,
                                    paises:this.state.paises,
                                    calendariosFormacion:this.state.calendariosFormacion,
                                    herramientaAnalisis:this.state.herramientaAnalisis
                                })
                        ))
                        : null
                    }
                </div>
                <ModalMultimedia class="divGestorArchivosMultimedia" callback={this.getResponseMultimedia.bind(this)}/>
            </div>
        )
    }

    renderSwitch(modulo, pagina_id, pModIdEdit, mWebEdit, callback, recursos = {}) {
        switch(modulo.id) {
            case 1:
                return <AdmBanner modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 2:
                return <AdmPerfilador perfiles={recursos.perfiles} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 3:
                return <AdmDetallePerfilador perfiles={recursos.perfiles} sectores={recursos.sectores}  modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 4:
                return <AdmBeneficioCliente perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 16:
                return <AdmNoticia perfiles={recursos.perfiles} sectores={recursos.sectores} recursoNoticias={recursos.recursoNoticias} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 17:
                return <AdmModuloServicioExportador perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 18:
                return <AdmModuloReporteExportacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 19:
                return <AdmModuloEvento perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 20:
                return <AdmDiagnosticoProducto perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 22:
                return <AdmProductoPriorizado perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 24:
                return <AdmCertificacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 26:
                return <AdmRegulacionPais perfiles={recursos.perfiles} sectores={recursos.sectores} paises={recursos.paises} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 28:
                return <AdmCapsulaAprendizaje perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 29:
                return <AdmFormacionExportador calendariosFormacion={recursos.calendariosFormacion} perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 30:
                return <AdmPotencialExportador perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 31:
                return <AdmInformeMercado perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 32:
                return <AdmDocumentacionExportar perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 33:
                return <AdmExportaFacil perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 34:
                return <AdmPreciosFob perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 35:
                return <AdmGuiasExportador perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 36:
                return <AdmExportacionProductoMercado perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 37:
                return <AdmExportacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 38:
                return <AdmPaginasInteres perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 39:
                return <AdmSliderSectoresProductivos perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 40:
                return <AdmSliderCompetitividadGlobal perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 41:
                return <AdmPerfilProductoMercado perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 42:
                return <AdmEstudioMercado perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 43:
                return <AdmExportacionDirectorioContacto perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 44:
                return <AdmHerramientaPymes perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 45:
                return <AdmHerramientaExterna perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 46:
                return <AdmBoletinInteligencia perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 47:
                return <AdmProgramaCapacitacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 49:
                return <AdmMiercolesExportador perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 50:
                return <AdmCalendarioFormacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 51:
                return <AdmSliderProductoExportacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 52:
                return <AdmPublicacion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 53:
                return <AdmMenuAncla perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 54:
                return <AdmHerramientaAnalisis herramientaAnalisis={recursos.herramientaAnalisis} perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 55:
                return <AdmNuestrasOficinas perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 56:
                return <AdmPuedeInteresarte perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 57:
                return <AdmInfografia perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 59:
                return <AdmGlosario perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 60:
                return <AdmPreguntasFrecuentes perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 62:
                return <AdmRegistroUsuario perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 63:
                return <AdmBannerImagen perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 64:
                return <AdmEncuestaSatisfaccion perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 65:
                return <AdmCalendarioDetalle perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 66:
                return <AdmCalendarioEventos perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 67:
                return <AdmMapaSitio perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 68:
                return <BuscadorPartidas perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 69:
                return <BuscadorProductos perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 70:
                return <BuscadorPaises perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 25:
                return <AdmContenido perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 71:
                return <AdmBannerImagenHome perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 72:
                return <AdmNoticiasHome modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 73:
                return <AdmMacrotendenciaHome perfiles={recursos.perfiles} sectores={recursos.sectores} recursoNoticias={recursos.recursoNoticias} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            case 74:
                return <AdmEventoHome perfiles={recursos.perfiles} sectores={recursos.sectores} modulo={modulo} pagina={pagina_id} pmodId={pModIdEdit} mWebEdit={mWebEdit} callback={callback} key={"FormularioCreacion_" + modulo.id}/>;
            default:
                return null;
        }
    }
}